import React, { Fragment, memo } from 'react'

import { useUnit } from 'effector-react'

import { palette } from 'helpers/palette'

import Icon from 'components/_old/Icon/Icon.jsx'
import Input from 'components/_old/Input/Input.jsx'
import { Typo } from 'components/_old/Typo'

import { ItemWithIcon } from 'components/atoms/ItemWithIcon'
import { Typography } from 'components/atoms/Typography'

import { $form } from '../../index'

const PartType = memo(() => {
  const [form] = useUnit([$form])

  return (
    <Fragment>
      <Input type="hidden" name="part_type" value={form.part_type ?? ''} />
      <ItemWithIcon
        icon={<Icon type="information-16" color={palette['content-on-background-default']} size={16} />}
        iconVerticalAlign="center"
        space={16}
        content={
          <Typography size={14}>
            <Typo>We only accept full pension transfers — partial transfers are not supported.</Typo>
          </Typography>
        }
        contentVerticalAlign="center"
      />
    </Fragment>
  )
})
PartType.displayName = 'PartType'

export { PartType }
